module.exports = __webpack_public_path__ + "img/clock-blue.b270cd9f.svg";